module.exports = __webpack_public_path__ + "img/15-1_04.e651538a.jpg";